import { USER_ROLE } from 'configs/constants';
import GtagService from 'modules/app/services/ga/GtagService';

const VIEW_AS = 'ViewAs';

class SidebarEvents {
  sendClick = (options) => {
    GtagService.sendClick({
      subcategory: 'VerticalMenu',
      ...options
    });
  };

  sendPreviewAs = (role) => {
    const event = {
      [USER_ROLE.OWNER]: 'Producer',
      [USER_ROLE.STUDENT]: 'Student',
      [USER_ROLE.FREE_STUDENT]: 'FreeStudent'
    };

    this.sendClick({ where: VIEW_AS, label: event[role] || VIEW_AS });
  };
}

export default new SidebarEvents();
